import { render, staticRenderFns } from "./ParticaTreeMenu.vue?vue&type=template&id=408bd70c&scoped=true&"
import script from "./ParticaTreeMenu.vue?vue&type=script&lang=ts&"
export * from "./ParticaTreeMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaTreeMenu.vue?vue&type=style&index=0&id=408bd70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408bd70c",
  null
  
)

export default component.exports